<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
        <div class="form-group" [formGroup]="form">
        <app-action-alert controlName="bloodGlucose" [alerts]="item!.actionAlerts" [form]="form"></app-action-alert>
        <app-unit-quantity label="Blood Glucose" unitLabel="mmol/l" placeholder="Value" inputMode="decimal" formControlName="bloodGlucose"></app-unit-quantity>
        </div>
        <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls> 
    </div>
</app-action-form>
